/**
 * Today, triggers are created to trigger/run jobs.
 * So, this panel is displayed while creating a trigger if the project
 * or entity (in the case of triggers from the Model registry)
 * has no jobs in it.
 */
import DocUrls from '@wandb/common/util/doc_urls';
import {TargetBlank} from '@wandb/common/util/links';
import React from 'react';

import {Button} from '../../../Button';
import * as S from './EmptyTriggerDrawer.styles';

export const EmptyTriggerDrawer = () => {
  return (
    <S.Panel>
      <S.OffsetUp>
        <S.Circle>
          <S.LightBulb />
        </S.Circle>
        <S.Heading>You'll need jobs to create automations.</S.Heading>
        <S.Message>
          Jobs are reusable, configurable run templates that allow you to
          quickly launch new runs or create automations, locally or using extra
          GPUs. Weights & Biases will automatically create jobs from any runs
          that have code saving enabled.
        </S.Message>
        <S.Buttons>
          <TargetBlank href={DocUrls.launch}>
            <Button
              size="large"
              variant="secondary"
              icon="documentation"
              style={{marginRight: '8px'}}>
              Jobs documentation
            </Button>
          </TargetBlank>
          <TargetBlank href={DocUrls.codeSaving}>
            <Button size="large" variant="secondary" icon="documentation">
              Enabling code saving
            </Button>
          </TargetBlank>
        </S.Buttons>
      </S.OffsetUp>
    </S.Panel>
  );
};
